'use client';

import { Typography } from '@curology/ui-components-web/react/Typography';
import Image from 'next/image';
import React, { useState } from 'react';

import { useFlowContext } from '@/components/flow/hooks/useFlowContext';
import { type Ingredient } from '@/types/productSelectionAndCheckout/types';

const IngredientTabs: React.FC<{
  ingredients: Ingredient[];
}> = ({ ingredients }) => {
  const { brand } = useFlowContext();

  const [selectedIngredientIndex, setSelectedIngredientIndex] = useState(0);

  const selectedIngredient = ingredients[selectedIngredientIndex];

  const unselectedIngredientBorderColorClass =
    brand === 'agency' ? 'cur-border-[#cbc5bf]' : 'cur-border-transparent';

  const bottomBorderClass =
    brand === 'agency' ? 'cur-border-b' : 'cur-border-b-2';

  return (
    <div>
      <ul className="cur-flex cur-mb-0 cur-overflow-x-auto">
        {ingredients.map((ingredient, index) => {
          const divBorderClass =
            index === selectedIngredientIndex
              ? 'cur-border-border-secondary'
              : unselectedIngredientBorderColorClass;

          return (
            <li className="cur-shrink-0" key={ingredient.name}>
              <div
                className={`cur-p-4 ${bottomBorderClass} ${divBorderClass}`}
                onClick={(event) => {
                  event.stopPropagation();

                  setSelectedIngredientIndex(index);
                }}
              >
                <Image
                  alt={ingredient.image.alt}
                  height="40"
                  src={ingredient.image.url}
                  width="40"
                />
              </div>
            </li>
          );
        })}
      </ul>
      <div className="cur-pt-4">
        <Typography className="cur-mb-2" weight="bold">
          {selectedIngredient.name}
        </Typography>
        <Typography className="cur-my-2">
          {selectedIngredient.description}
        </Typography>
        <Typography className="cur-text-surface-secondary cur-mt-2" size="meta">
          Ingredients subject to consultation.
        </Typography>
      </div>
    </div>
  );
};

export default IngredientTabs;
